import type { VisualMatch } from '@frameio/graphql-client/generated';
import { convertMillisecondsToSeconds } from '@frameio/utils/formatters';

/**
 * Returns the width and offset for each subclip in a timeline relative to the duration of the total clip.
 */
export const getClipRanges = (
  clips: VisualMatch['clips'],
  duration: number
) => {
  if (!clips?.length || duration === 0) return [];

  return clips.map((clip) => {
    const startAtInSeconds = convertMillisecondsToSeconds(clip?.startTime ?? 0);
    const endAtInSeconds = convertMillisecondsToSeconds(clip?.endTime ?? 0);
    const width = ((endAtInSeconds - startAtInSeconds) / duration) * 100;
    const offsetLeft = (startAtInSeconds / duration) * 100;

    return {
      width,
      offsetLeft,
    };
  });
};
